import { changeUrlSlug as changeUrlSlugCommon } from 'app-source/actions/changeUrlSlug';
import { TRENDING_ITEM, TRENDING } from '../../../routes/types';

export const changeUrlSlug = (slug) => changeUrlSlugCommon(TRENDING_ITEM, TRENDING)({ slug });
